
import React from "react";
import {  Input } from "antd";
import { Helmet } from "react-helmet";
import "./EmployerHelp.css";
import { Link } from "react-router-dom";
import { SVGicon } from "../../../styleGuide/SVGicon/SVGicon";

const { Search } = Input;


export const EmployerHelp = () => {
     return (
          <>
               <Helmet>
                    <title>Employer Help | Metropolis</title>
               </Helmet>


               {/* // _BEGIN > SECTION - CLAIM EMPLOYER PROFILE BANNER< RIA // */}
               <section className="sector-sign-up-banner sector-help-banner">
                    <div className="mtp-container-fluid">
                         <div className="section-header-lg sector-help-page">
                              <h2 className="section-header-lg-primary-heading text-color-white fw-700 ">
                                   How can we help you today?
                              </h2>
                              <div className="help-search-wrap">
                                        <Search placeholder="Search for help topics here." className="mtp-help-search-input" enterButton />
                              </div>
                         </div>
                    </div>
               </section>
               {/* // _ENDS > SECTION - CLAIM EMPLOYER PROFILE BANNER< RIA // */}

               {/* // _BEGIN > EMPLOYER HELP PAGE < RIA // */}
               <section className="employer-help-page ground-color-ashes">
                    <div className=" mtp-container">
                         <div className="employer-help-page-wrap">
                              <div className="employer-help-page-head-wrap">
                                   <h6 className="fw-600 text-color-alpha">Employer Help Page</h6>
                                   <p className="fw-400 text-color-bravo">Not an employer? Click to see the <Link className=" fw-500 job-seeker-view-link">Job Seeker view</Link> </p>
                              </div>
                              <div className="employer-help-page-multiple-section">
                                   <Link>
                                        <div className="employer-help-page-card">
                                             <div className="employer-help-page-card-icon flex-center flex-center-auto-0">{SVGicon.mtpIconmtpBasics}</div>
                                             <p className="employer-help-page-card-title fw-500 text-color-alpha text-center">Metropolis Basics</p>
                                        </div>
                                   </Link>
                                   <Link>
                                        <div className="employer-help-page-card">
                                             <div className="employer-help-page-card-icon flex-center flex-center-auto-0">{SVGicon.mtpIconLegalFaq}</div>
                                             <p className="employer-help-page-card-title fw-500 text-color-alpha text-center">Legal FAQs</p>
                                        </div>
                                   </Link>
                                   <Link>
                                        <div className="employer-help-page-card">
                                             <div className="employer-help-page-card-icon flex-center flex-center-auto-0">{SVGicon.mtpIconmtpCompanyProfile}</div>
                                             <p className="employer-help-page-card-title fw-500 text-color-alpha text-center">Manage Company Profile</p>
                                        </div>
                                   </Link>
                                   <Link>
                                        <div className="employer-help-page-card">
                                             <div className="employer-help-page-card-icon flex-center flex-center-auto-0">{SVGicon.mtpIconCompanyReviews}</div>
                                             <p className="employer-help-page-card-title fw-500 text-color-alpha text-center">Manage Company Reviews</p>
                                        </div>
                                   </Link>
                                   <Link>
                                        <div className="employer-help-page-card">
                                             <div className="employer-help-page-card-icon flex-center flex-center-auto-0">{SVGicon.mtpIconCenterBasics}</div>
                                             <p className="employer-help-page-card-title fw-500 text-color-alpha text-center">Employer Center Basic</p>
                                        </div>
                                   </Link>
                                   <Link>
                                        <div className="employer-help-page-card">
                                             <div className="employer-help-page-card-icon flex-center flex-center-auto-0">{SVGicon.mtpIconJobPosting}</div>
                                             <p className="employer-help-page-card-title fw-500 text-color-alpha text-center">Job Posting</p>
                                        </div>
                                   </Link>
                                   <Link>
                                        <div className="employer-help-page-card">
                                             <div className="employer-help-page-card-icon flex-center flex-center-auto-0">{SVGicon.mtpIconPrivacyTrust}</div>
                                             <p className="employer-help-page-card-title fw-500 text-color-alpha text-center">Privacy & Trust</p>
                                        </div>
                                   </Link>
                                   <Link>
                                        <div className="employer-help-page-card">
                                             <div className="employer-help-page-card-icon flex-center flex-center-auto-0">{SVGicon.mtpIconOnboarding}</div>
                                             <p className="employer-help-page-card-title fw-500 text-color-alpha text-center">Onboarding</p>
                                        </div>
                                   </Link>
                                   <Link>
                                        <div className="employer-help-page-card">
                                             <div className="employer-help-page-card-icon flex-center flex-center-auto-0">{SVGicon.mtpIconWebinar}</div>
                                             <p className="employer-help-page-card-title fw-500 text-color-alpha text-center">Webinars</p>
                                        </div>
                                   </Link>

                              </div>
                         </div>
                    </div>
               </section>
               {/* // _ENDS > EMPLOYER HELP PAGE < RIA // */}

               <div className="employer-help-page-divider"></div>
               {/* // _BEGIN > EMPLOYER HELP PAGE INFORMATION< RIA // */}
               <section className="employer-help-page-info-content ground-color-ashes">
                    <div className=" mtp-container">
                         <div className="employer-help-page-info-content-card">
                              <div className="employer-help-page-info-content-inner-card">
                                   <h6 className="fw-600">Trending Articles</h6>
                                   <p className="fw-400"> <Link className="employer-help-page-info-content-card-link">Tell me about some of Metropolis’s successful legal efforts to defend user anonymity.</Link></p>
                                   <p className="fw-400"> <Link className="employer-help-page-info-content-card-link">Job Alerts on Metropolis</Link></p>
                                   <p className="fw-400"> <Link className="employer-help-page-info-content-card-link">How does Metropolis respond to legal requests or legal action to find out who posted a review?</Link></p>
                                   <p className="fw-400"> <Link className="employer-help-page-info-content-card-link">Give to get policy</Link></p>
                                   <p className="fw-400"> <Link className="employer-help-page-info-content-card-link">Ratings on Metropolis</Link></p>
                              </div>
                              <div className="employer-help-page-info-content-inner-card">
                                   <h6 className="fw-600">Community Guidelines</h6>
                                   <p className="fw-400"> Metropolis follows simple principles and guidelines to ensure the most authentic, transparent, and valuable information is available to workers and job candidates while balancing fairness to employers.</p>
                                   <p className="fw-400"> <Link className="employer-help-page-info-content-card-link">Community Guidelines</Link></p>
                                   <p className="fw-400"> <Link className="employer-help-page-info-content-card-link">Privacy Policy</Link></p>
                                   <p className="fw-400"> <Link className="employer-help-page-info-content-card-link">Global Privacy Commitment</Link></p>
                              </div>
                              <div className="employer-help-page-info-content-inner-card">
                                   <h6 className="fw-600">Legal FAQs</h6>
                                   <p className="fw-400"> View articles providing important information on legal topics related to using Metropolis, including posting/responding to reviews, how Metropolis approaches certain common issues and how it fights to protect users’ anonymous free speech rights as appropriate.</p>
                                   <p className="fw-400"> <Link className="employer-help-page-info-content-card-link">Legal FAQs</Link></p>
                              </div>
                         </div>
                    </div>
               </section>
               {/* // _END > EMPLOYER HELP PAGE INFORMATION< RIA // */}
          </>
     )
}